import { SubmitHandler, useForm } from 'react-hook-form';
import { IFormValues } from './interface';
import { useLazyQuery } from '@apollo/client/react';
import { submitFeedback } from 'graphql/queries';

interface IFormValuesExtended extends IFormValues {
    takeActionFromTips?: string;
    anythingElse?: string;
    overallExperienceRating?: string;
    howEasyRating?: string;
}

export const useCreateFeedback = () => {
    const { register, handleSubmit } = useForm<IFormValuesExtended>();

    const [submitForm] = useLazyQuery(submitFeedback);

    const onSubmit: SubmitHandler<IFormValuesExtended> = data => {
        const { overallExperienceRating, howEasyRating, takeActionFromTips, anythingElse } = data;

        submitForm({
            variables: {
                input: {
                    overallExperienceRating: overallExperienceRating?.toString(),
                    howEasyRating: howEasyRating?.toString(),
                    takeActionFromTips,
                    anythingElse,
                },
            },
        });
    };

    return {
        register,
        handleSubmit,
        onSubmit,
    };
};
